import { type SearchSettings, useSearchkitClient } from "@/hooks/use-searchkit-client";

// Hoisted so `useSearchkitClient`'s memo deps stay reference-stable across
// renders. Per-page Searchkit config never depends on hook state.
const SEARCH_SETTINGS: SearchSettings = {
  // Searchkit reads `insideBoundingBox` from InstantSearch UI state and emits an
  // ES `geo_bounding_box` filter against this field. Members with no `location`
  // (not on a trip today) are absent from this field and so drop out of
  // map-bounded results, but still appear in the unfiltered grid.
  geo_attribute: "location",
  // Target Searchkick's `.word_middle` subfield for typo/prefix-friendly matching.
  search_attributes: [{ field: "name.word_middle", weight: 3 }, "handle.word_middle", "bio.word_middle"],
  result_attributes: [
    "id",
    "handle",
    "display_name",
    "name",
    "initial",
    "color",
    "type",
    "avatar",
    "location",
    "location_label",
  ],
  highlight_attributes: [],
  facet_attributes: [],
  sorting: {
    default: { field: "_score", order: "desc" },
  },
};

export function useMembersSearch() {
  return useSearchkitClient({
    host: "/api/members",
    indexName: "members",
    searchSettings: SEARCH_SETTINGS,
    sessionKey: "members",
  });
}
